import Swiper from 'swiper/swiper-bundle';

export class WbSliders {
  constructor() {
    this.navigation = {
      nextEl: '.wb-swiper-btm-bar__arrow--next',
      prevEl: '.wb-swiper-btm-bar__arrow--prev',
      disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
    };

    this.pagination = {
      el: '.wb-swiper-btm-bar__pagination',
      bulletElement: 'button',
      bulletClass: 'wb-swiper-btm-bar__pagination__el',
      bulletActiveClass: 'wb-swiper-btm-bar__pagination__el--active',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      },
    };

    this.events = {
      on: {
        lock: function (e) {
          this.el.querySelector('.wb-swiper-btm-bar')._hide(0);
        },
        unlock: function (e) {
          this.el
            .querySelector('.wb-swiper-btm-bar')
            ._show(0)
            .then(() => (this.el.querySelector('.wb-swiper-btm-bar').style.display = 'flex'));
        },
      },
    };
  }

  init() {
    return new Promise((resolve, reject) => {
      this.initGallerySliders();
      this.initEntrySliders();
      this.initAdsSliders();
      this.initCompanySliders();
      resolve();
    });
  }

  initGallerySliders() {
    document.querySelectorAll('.wb-gallery__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: this.navigation,
        pagination: this.pagination,
        breakpoints: {
          576: {
            spaceBetween: 20,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            spaceBetween: 30,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1400: {
            spaceBetween: 30,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          2000: {
            spaceBetween: 40,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        ...this.events,
      });
    });
  }

  initEntrySliders() {
    document.querySelectorAll('.wb-entry-slider__slider')?.forEach((slider) => {
      let breakpoints = {};

      if (slider.closest('.wb-entry-slider--2')) {
        breakpoints = {
          992: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          2000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        };
      } else {
        breakpoints = {
          576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1400: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          2000: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        };
      }

      new Swiper(slider, {
        slidesPerView: 1.1,
        spaceBetween: 10,
        loop: false,
        navigation: this.navigation,
        pagination: this.pagination,
        breakpoints,
        ...this.events,
      });
    });
  }

  initAdsSliders() {
    document.querySelectorAll('.wb-ads__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1000,
      });
    });
  }

  initCompanySliders() {
    document.querySelectorAll('.wb-members-featured__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        navigation: this.navigation,
        pagination: this.pagination,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        ...this.events,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          1400: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        },
      });
    });
  }
}
